exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".check___PCuT4 {\n  background-image: url(" + require("../../../../../assets/images/greenCheck.svg") + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 1em;\n  width: 1em;\n  display: inline-block;\n  vertical-align: middle;\n}\n", ""]);

// exports
exports.locals = {
	"check": "check___PCuT4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/modals/WeddingShopItemsModal/icons.module.less
// module id = 1699
// module chunks = 70